export default "__VITE_ASSET__CnZkjUr9__"